const MAX_IMPRESSIONS_PER_HIT = 10;

export interface IGtmData {
    event: string;
    button?: string;
    ecommerce?: {
        checkout?: unknown;
        currencyCode?: unknown;
        impressions?: object[];
        purchase?: unknown;
        items?: object[];
        item_list_id?: string;
        item_list_name?: string;
    };
    action?: string;
    label?: string | number;
    event_action?: string;
    event_label?: string | number;
    event_category?: string;
    event_category2?: string;
    event_category3?: string;
    event_category4?: string;
    custom_label?: string;
}

export const hitGoogleTagManager = <GtmData extends IGtmData>(gtmData: GtmData) => {
    const win = window as Window;

    win.dataLayer = win.dataLayer || [];
    if ((gtmData.ecommerce?.impressions?.length ?? 0) > MAX_IMPRESSIONS_PER_HIT) {
        // start impressions chunking
        const impressions = gtmData!.ecommerce!.impressions!; // because we validate that field earlier
        const chunks = Math.ceil(impressions.length / MAX_IMPRESSIONS_PER_HIT);
        for (let i = 0; i < chunks; ++i) {
            const chunkData = structuredClone(gtmData);
            if (chunkData.ecommerce) {
                chunkData.ecommerce.impressions = impressions.slice(i * MAX_IMPRESSIONS_PER_HIT, (i + 1) * MAX_IMPRESSIONS_PER_HIT);
            }
            win.dataLayer.push(chunkData);
        }
    } else {
        win.dataLayer.push(gtmData);
    }
};
const MAX_IMPRESSIONS_PER_HIT = 10;

export interface IGtmData {
    event: string;
    button?: string;
    ecommerce?: {
        checkout?: unknown;
        currencyCode?: unknown;
        impressions?: object[];
        purchase?: unknown;
        items?: object[];
        item_list_id?: string;
        item_list_name?: string;
    };
    action?: string;
    label?: string | number;
    event_action?: string;
    event_label?: string | number;
    event_category?: string;
    event_category2?: string;
    event_category3?: string;
    event_category4?: string;
    custom_label?: string;
}

export const hitGoogleTagManager = <GtmData extends IGtmData>(gtmData: GtmData) => {
    const win = window as Window;

    win.dataLayer = win.dataLayer || [];
    if ((gtmData.ecommerce?.impressions?.length ?? 0) > MAX_IMPRESSIONS_PER_HIT) {
        // start impressions chunking
        const impressions = gtmData!.ecommerce!.impressions!; // because we validate that field earlier
        const chunks = Math.ceil(impressions.length / MAX_IMPRESSIONS_PER_HIT);
        for (let i = 0; i < chunks; ++i) {
            const chunkData = structuredClone(gtmData);
            if (chunkData.ecommerce) {
                chunkData.ecommerce.impressions = impressions.slice(i * MAX_IMPRESSIONS_PER_HIT, (i + 1) * MAX_IMPRESSIONS_PER_HIT);
            }
            win.dataLayer.push(chunkData);
        }
    } else {
        win.dataLayer.push(gtmData);
    }
};
